import React, { useEffect, useRef, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { get } from 'lodash';

import messages from 'containers/RecapManagerPage/messages';
import { translate } from 'containers/services/translate';
import ValidationDrawer from 'containers/RecapManagerPage/ValidationDrawer';
import { Listings } from 'containers/AppContainer/typings';
import RejectionDrawer from 'containers/RecapManagerPage/RejectionDrawer';
import {
  formatValidationCompletionClaim,
  isClaimPendingClaim,
  isNotCompletedClaim,
  isPendingCompletionUsageClaim,
} from 'containers/RecapManagerPage/utils';
import { toast } from 'react-toastify';

import DropDownDecisionMenu from 'components/SahamDropDown/DropDownDecisionMenu';
import { DecisionWrapper } from 'containers/RecapManagerPage/styled-components';
import AssignmentDialog from 'containers/RecapManagerPage/AssignmentDialog';
import SuccessDialog from 'components/SuccessDialog';
import { PAGES } from 'routes';
import { pushTo } from 'containers/services/routes-helper';
import { CLAIM, CLAIM_STATUS, LISTINGS } from 'containers/data-structure';
import { isActivateOpenClaimSagis } from 'containers/RecapManagerPage/utils';
import { KeycloakUser } from 'containers/RecapManagerPage/typings';
import { Claim } from 'containers/PreOpeningPage/typings';
import { ClaimRecapType } from 'typings/claimTypes';
import { CHOICE } from 'containers/PreOpeningPage/constants';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import ConfirmationDialog from 'containers/RecapManagerPage/ConfirmationDialog';
import { useSelector } from 'react-redux';
import { useLastLocation } from 'react-router-last-location';
export interface DecisionComponentProps {
  intl: IntlShape;
  claimId: number;
  listings: Listings;
  requestRejectClaim: Function;
  claimRecap: ClaimRecapType;
  requestOpenClaim: Function;
  requestOpenMixedClaim: Function;
  requestAssigment: Function;
  requestCorporealLawyers: Function;
  corporealLawyers: KeycloakUser[];
  policyInfo: { sagis: {} };
  requestSearchClaims: Function;
  openedClaim: any;
  dataClaimToUpdate?: any;
  setOpenFeeNoteDialog: Function;
  isSearchExecuted?: any;
  setIsProvisionalReferenceAlertOpenned?: Function;
  requestValidateCompletionClaimManager: Function;
}

const DecisionComponent: React.FC<DecisionComponentProps> = (
  props,
): JSX.Element => {
  const [openDropDown, setOpenDropDown] = React.useState<null | HTMLElement>(
    null,
  );
  const [
    openDialogCompletionUsageClaim,
    setOpenDialogCompletionUsageClaim,
  ] = React.useState<boolean>(false);
  const { claim } = props.claimRecap;

  const activateOpenClaimSagis = isActivateOpenClaimSagis(
    get(props.listings, 'appConfig', []),
  );
  const validateCompletionUsageClaim = isPendingCompletionUsageClaim(claim);
  const notCompletedClaim = isNotCompletedClaim(claim);
  const [openClaimWithoutSagis, setOpenClaimWithoutSagis] = useState(false);

  const [isRejectionDrawerOpen, setIsRejectionDrawerOpen] = useState(false);
  const [isValidationDrawerOpen, setIsValidationDrawerOpen] = useState(false);

  const handleToggleRejectionDrawer = () => {
    setIsRejectionDrawerOpen(!isRejectionDrawerOpen);
    setOpenDropDown(null);
  };

  const handleToggleValidationDrawer = () => {
    setIsValidationDrawerOpen(!isValidationDrawerOpen);
    setOpenDropDown(null);
  };
  const handleToggleValidationWithoutCallSagisDrawer = () => {
    setIsValidationDrawerOpen(!isValidationDrawerOpen);
    setOpenDropDown(null);
    setOpenClaimWithoutSagis(true);
  };
  const handleToggleDialog = () => {
    setOpenDialogCompletionUsageClaim(!openDialogCompletionUsageClaim);
  };

  const dropDownMenuElement = validateCompletionUsageClaim
    ? [
        {
          title: translate(
            { ...messages.managerRecapPageValidationtButton },
            props,
          ),
          action: handleToggleDialog,
        },
      ]
    : activateOpenClaimSagis
    ? [
        {
          title: translate(
            { ...messages.managerRecapPageValidationtButton },
            props,
          ),
          action: handleToggleValidationDrawer,
        },
        {
          title: translate({ ...messages.managerRecapPageRejectButton }, props),
          action: handleToggleRejectionDrawer,
        },
      ]
    : get(props.claimRecap, 'claim.status') === CLAIM_STATUS.PENDING_APPROVAL
    ? [
        {
          title: translate(
            { ...messages.managerRecapPageValidationSagisButton },
            props,
          ),
          action: handleToggleValidationDrawer,
        },
      ]
    : notCompletedClaim
    ? [
        {
          title: translate(
            { ...messages.managerRecapPageValidationtButton },
            props,
          ),
          action: handleToggleValidationDrawer,
        },
        {
          title: translate({ ...messages.managerRecapPageRejectButton }, props),
          action: handleToggleRejectionDrawer,
        },
      ]
    : [
        {
          title: translate(
            { ...messages.managerRecapPageValidationtButton },
            props,
          ),
          action: handleToggleValidationDrawer,
        },
        {
          title: translate(
            { ...messages.managerRecapPageValidateBawabaButton },
            props,
          ),
          action: handleToggleValidationWithoutCallSagisDrawer,
        },
        {
          title: translate({ ...messages.managerRecapPageRejectButton }, props),
          action: handleToggleRejectionDrawer,
        },
      ];

  const [isSuccessDialogOpen, setIsSuccessDialogOpen] = React.useState<boolean>(
    false,
  );

  const [isAssignmentDialogOpen, setIsAssignmentDialogOpen] = React.useState<
    boolean
  >(false);

  const handleOpenAssignmentDialog = () => {
    setIsAssignmentDialogOpen(true);
    setIsSuccessDialogOpen(false);
  };

  const handleCloseAssignmentDialog = () => {
    setIsSuccessDialogOpen(false);
    pushTo(PAGES.MANAGER_HOME)();
  };

  function useOutsideAlerter(ref: HTMLElement | null) {
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (ref && !ref.contains(event.target)) {
          setOpenDropDown(null);
        }
      }
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  }

  const successCallBack = () => {
    setOpenDialogCompletionUsageClaim(false);
    toast.success(translate(messages.successValidationCompletionClaim, props));
  };
  const priorityReasonClaimId = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'priorityReasonId']),
  );
  const handleValidateCompletion = () => {
    const claimToValidate = formatValidationCompletionClaim(
      {
        ...props.claimRecap,
        documents: get(props.dataClaimToUpdate, 'documents', []),
        deletedDocuments: get(props.dataClaimToUpdate, 'deletedDocuments', []),
      },
      props.policyInfo,
      props.listings,
      priorityReasonClaimId,
    );
    props.requestValidateCompletionClaimManager(
      { ...claimToValidate },
      successCallBack,
    );
  };

  const wrapperRef = useRef<HTMLDivElement>(null);
  useOutsideAlerter(wrapperRef.current);

  return (
    <DecisionWrapper>
      {((!featureService.hasFeature(FEATURES.COURT_CALENDAR) &&
        isClaimPendingClaim(props.claimRecap)) ||
        (featureService.hasFeature(FEATURES.COURT_CALENDAR) &&
          isClaimPendingClaim(props.claimRecap) &&
          (!get(claim, [CLAIM.IS_PROVISIONAL], '') ||
            get(claim, [CLAIM.IS_PROVISIONAL], '') === CHOICE.NO ||
            (get(claim, [CLAIM.IS_PROVISIONAL], '') === CHOICE.YES &&
              props.isSearchExecuted)))) && (
        <div ref={wrapperRef}>
          <DropDownDecisionMenu
            label={translate(
              { ...messages.managerRecapPageDecisionButton },
              props,
            )}
            dropDown={openDropDown}
            setDropDown={setOpenDropDown}
            menuElements={dropDownMenuElement}
          />
        </div>
      )}
      {isRejectionDrawerOpen && (
        <RejectionDrawer
          open={isRejectionDrawerOpen}
          handleToggleDrawer={handleToggleRejectionDrawer}
          rejectionReasons={get(props.listings, 'rejectionReasons', []).filter(
            (el: any) => el.isVisible,
          )}
          claimId={props.claimId}
          requestRejectClaim={props.requestRejectClaim}
        />
      )}
      {isValidationDrawerOpen && (
        <ValidationDrawer
          open={isValidationDrawerOpen}
          handleToggleDrawer={handleToggleValidationDrawer}
          managementModes={get(props.listings, 'modeGestion', [])}
          responsabilities={get(props.listings, 'responsability', [])}
          scaleCases={get(props.listings, 'casDeBareme', [])}
          circumstances={get(props.listings, 'circumstance', [])}
          claimRecap={props.claimRecap}
          requestOpenClaim={props.requestOpenClaim}
          claimId={props.claimId}
          policyInfo={props.policyInfo}
          requestSearchClaims={props.requestSearchClaims}
          handleOnOpeningSuccessDialog={setIsSuccessDialogOpen}
          requestOpenMixedClaim={props.requestOpenMixedClaim}
          listing={props.listings}
          dataClaimToUpdate={props.dataClaimToUpdate}
          setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
          openClaimWithoutSagis={openClaimWithoutSagis}
          setIsProvisionalReferenceAlertOpenned={
            props.setIsProvisionalReferenceAlertOpenned
          }
        ></ValidationDrawer>
      )}

      <SuccessDialog
        open={isSuccessDialogOpen}
        title={translate({ ...messages.successDialogMessage }, props)}
        primaryButtonTitle={translate(
          messages.successDialogAssignToSubService,
          props,
        )}
        secondaryButtonTitle={translate(
          messages.successDialogGoBackToHomePage,
          props,
        )}
        homePath={PAGES.MANAGER_HOME}
        onPrimaryClick={handleOpenAssignmentDialog}
        onClose={setIsSuccessDialogOpen}
        isExpertReport={false}
      />
      <AssignmentDialog
        open={isAssignmentDialogOpen}
        onClose={handleCloseAssignmentDialog}
        subServices={get(props.listings, LISTINGS.SUB_SERVICES, [])}
        zonesCodes={get(props.listings, LISTINGS.ZONE_CODES, [])}
        services={get(props.listings, LISTINGS.SERVICES, [])}
        stackholders={get(props.listings, LISTINGS.STACKHOLDERS, [])}
        stackholderTypes={get(props.listings, LISTINGS.STACKHOLDER_TYPE, [])}
        requestAssigment={props.requestAssigment}
        claim={(props.claimRecap.claim as unknown) as Claim}
        requestCorporealLawyers={props.requestCorporealLawyers}
        corporealLawyers={props.corporealLawyers}
        shouldAssignOnSagis={false}
        isManagerOpenedClaimsPage={false}
        listings={props.listings}
        claimNumber={get(props.openedClaim, 'data.ClaimNumber')}
        isClaim
      />
      {openDialogCompletionUsageClaim && (
        <ConfirmationDialog
          confirmationDialog={openDialogCompletionUsageClaim}
          handleCloseConfirmationDialog={handleToggleDialog}
          handleValidate={handleValidateCompletion}
        />
      )}
    </DecisionWrapper>
  );
};
export default injectIntl(DecisionComponent);
